export default {
  title: 'Login'
}
